import { useSharedStackScreenOptions } from '@hooks/useSharedStackScreenOptions';
import { Stack } from 'expo-router';

export default function ProfileLayout(): React.ReactNode {
  const screenOptions = useSharedStackScreenOptions();

  return (
    <Stack screenOptions={screenOptions}>
      <Stack.Screen
        name="index"
        options={{
          headerShown: false,
        }}
      />
    </Stack>
  );
}
